export enum ValidationStatus {
  Created = "Created",
  InProgress = "InProgress",
  Completed = "Completed",
  Cancelled = "Cancelled",
  Aborted = "Aborted"
}

export enum ValidationResults {
  Error = "error",
  Warning = "warning",
  Success = "success",
  Skipped = "skipped"
}

export enum PreValidationStatus {
  Rejected = "Rejected",
  Accepted = "Accepted"
}
